import { memo } from "react";

import { Text } from "@/components/atoms/Text";
import { Stack } from "@/components/atoms/Stack";
import type { TextVariant } from "@/components/atoms/types";
import { ifWeb } from "@/utils/platform";

/**
 * View component for empty list state
 */
const ListEmptyView = () => (
  <Stack className="flex-1 items-center gap-3 pt-16">
    <Text
      variant={ifWeb<TextVariant>("title", "display-sm")}
      className="text-center"
    >
      No Players
    </Text>
    <Text
      variant="unstyled"
      className={`text-center font-medium ${ifWeb("text-body", "text-title-sm")} text-content-muted`}
    >
      Add players to this list to get started.
    </Text>
  </Stack>
);

ListEmptyView.displayName = "ListEmptyView";

export default memo(ListEmptyView);
